import React, { useContext, useEffect } from "react";
import questionIcon from "../../img/Question_icon.svg";
import { StyledBadge, StyledCardBilled, StyledCardContainer, StyledCardHeader, StyledCardPrice, StyledCardSessions, StyledCardTitle } from "./plans.style";
import Tooltip from "../utils/Tooltip";
import FixelDataContext from "../../context/FixelDataContext";
import LinkButton from "../linkButton/linkButton.component";

const PlanCard = ({ plan }, props) => {
  const { fullFixelData } = useContext(FixelDataContext);


  const { id, name, price, terms } = plan;
  console.log('plan:', plan);

  const planType = fullFixelData.plan && fullFixelData.plan.type.toLowerCase();
  const isCurrentActivePlan =
        planType &&
        planType.toLowerCase() === plan.name.replace(" ", "_").toLowerCase() &&
        fullFixelData.plan &&
        fullFixelData.plan.state.toLowerCase() === "active";
  const isActivePlan = fullFixelData.plan && fullFixelData.plan.state.toLowerCase() === "active";

  return (
    <StyledCardContainer>
      {isActivePlan && isCurrentActivePlan && <StyledBadge>ACTIVE</StyledBadge>}
      <StyledCardHeader>
        <StyledCardTitle>{name}</StyledCardTitle>
        <StyledCardPrice>
          <span>{price}</span>/ month
        </StyledCardPrice>
        <StyledCardBilled>Billed monthly</StyledCardBilled>
      </StyledCardHeader>
      <StyledCardSessions>
        <span>{terms}</span>
        <Tooltip content="A session is the period of time a user is actively engaged with your website (similar to Google Analytics sessions).">
          <img src={questionIcon} alt="Information" />
        </Tooltip>
      </StyledCardSessions>
      <LinkButton type="button" value={id} disabled={isActivePlan && isCurrentActivePlan} to={{pathname: `plans/checkout/${plan.arrayId}`,state: plan}}>
              {(isActivePlan && isCurrentActivePlan) || planType === "trial" || !isActivePlan ? "subscribe" : "change plan"}
      </LinkButton>
    </StyledCardContainer>
  );
};
export default PlanCard;